import { render } from "./WhatDoNew.vue?vue&type=template&id=2ebcc72d&scoped=true"
import script from "./WhatDoNew.vue?vue&type=script&lang=js"
export * from "./WhatDoNew.vue?vue&type=script&lang=js"

import "./WhatDoNew.vue?vue&type=style&index=0&id=2ebcc72d&scoped=true&lang=scss"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebcc72d"]])

export default __exports__